enum VERIFICATION_STATUS {
    PENDING = 'pending',
    APPROVED ='approved',
    EXPIRED = 'expired',
}

enum SEND_METHOD  {
    SMS = 'sms',
    CALL = 'call',
}
export { VERIFICATION_STATUS, SEND_METHOD }